import { useDefineProviderRoute } from "@versatile-credit-apply/composition"
import { type RouteRecordRaw } from "vue-router"
import {
  ScreenId,
  type StaticProviderKey,
} from "@versatile-credit-apply/omni-apply-client"
import { baseProviderPath } from "@/router/utils"

const providerKey: StaticProviderKey = "synchrony_standard"
const { defineRoute } = useDefineProviderRoute(providerKey)

export const routes: RouteRecordRaw[] = [
  {
    name: "synchrony.routes",
    path: baseProviderPath("synchrony_standard"),
    children: [
      {
        name: "synchrony.generic.experience-type",
        path: ":experienceType",
        children: [
          {
            name: "synchrony.apply.routes",
            path: "apply",
            children: [
              {
                name: "synchrony.review-offer",
                path: ":applyStage/:planCode/review",
                component: () => import("./views/SynchronyReviewOfferView.vue"),
                props: true,
                meta: {
                  step: "decision",
                },
              },
              {
                name: "synchrony.pending-external-application",
                path: "full/responses/pending/reason/complete_via_external_url",
                component: () =>
                  import("./views/SynchronyMPQDeliveryOptionsView.vue"),
                props: true,
                meta: {
                  step: "decision",
                },
              },
              {
                name: "synchrony.paylater-options",
                path: "full/responses/pending/reason/complete_via_external_url/options",
                component: () => import("./views/SynchronyMPQLinkView.vue"),
                props: true,
                meta: {
                  step: "decision",
                },
              },
              {
                name: "synchrony.paylater-no-options",
                path: "full/responses/pending/reason/complete_via_external_url/no-options",
                component: () =>
                  import("./views/SynchronyLoanNoOptionsView.vue"),
              },
              {
                name: "synchrony.paylater-complete-application",
                path: "full/responses/pending/reason/complete_via_external_url/:deliveryType",
                component: () =>
                  import("./views/SynchronyLoanLinkResolverView.vue"),
                props: true,
                meta: {
                  step: "decision",
                },
              },
            ],
          },
        ],
      },
    ],
  },
  defineRoute({
    path: "/apply/:applyStage/responses/approved",
    inherit: true,
    component: () =>
      import("@/providers/synchrony_standard/views/SynchronyApprovedView.vue"),
  }),

  defineRoute({
    path: "/apply/:applyStage/responses/prequalified",
    inherit: true,
    component: () => import("@/views/apply/ExploreOffersView.vue"),
    meta: {
      screenId: ScreenId.OFFER_PRESENTATION_PREQUAL,
    },
  }),

  defineRoute({
    path: "/apply/offer/terms",
    inherit: true,
    component: () =>
      import("@/providers/synchrony_standard/views/SynchronyOfferTermsView.vue"),
  }),

  defineRoute({
    path: "/apply/full/terms",
    inherit: true,
    component: () =>
      import("@/providers/synchrony_standard/views/SynchronyApplyTermsView.vue"),
  }),
]
